import React from 'react'
import { connect } from 'react-redux'
import { Layout } from 'antd'
import { Link, withRouter } from 'react-router-dom'
import classNames from 'classnames'
// import SupportChat from 'components/cleanui/layout/SupportChat'
import style from './style.module.scss'

const mapStateToProps = ({ settings }) => ({
  logo: settings.logo,
  isGrayTopbar: settings.isGrayTopbar,
  isCardShadow: settings.isCardShadow,
  isSquaredBorders: settings.isSquaredBorders,
  isBorderless: settings.isBorderless,
  authPagesColor: settings.authPagesColor,
})

const MailLayout = ({
  children,
  logo,
  isGrayTopbar,
  isCardShadow,
  isSquaredBorders,
  isBorderless,
  authPagesColor,
}) => (
  <Layout>
    <Layout.Content>
      {/*         <SupportChat />
       */}
      <div
        className={classNames(`${style.container}`, {
          cui__layout__squaredBorders: isSquaredBorders,
          cui__layout__cardsShadow: isCardShadow,
          cui__layout__borderless: isBorderless,
          [style.white]: authPagesColor === 'white',
          [style.gray]: authPagesColor === 'gray',
        })}
        style={{
          backgroundImage:
            authPagesColor === 'image' ? 'url(resources/images/content/photos/7.jpg)' : '',
        }}
      >
        <div
          className={classNames(`${style.topbar}`, {
            [style.topbarGray]: isGrayTopbar,
          })}
        >
          <div className={style.logoContainer}>
            <div className={style.logo}>
              <img
                src="/resources/images/logo-Mobidoc-inline.png"
                className={`${style.image} me-2`}
                alt="Mobidoc"
              />
              <div className={style.name}>{logo}</div>
              {logo === 'Mobidoc' && <div className={style.descr}>Your personal assistant</div>}
            </div>
          </div>
          <div className="d-none d-sm-block">
            <span className="me-2">Go Back to </span>
            <Link to="/auth/login" className="font-size-16 kit__utils__link">
              Login Page
            </Link>
          </div>
        </div>
        <div className={style.containerInner}>{children}</div>
        <div className="mt-auto pb-5 pt-5">
          <ul
            className={`${style.footerNav} list-unstyled d-flex mb-0 flex-wrap justify-content-center`}
          >
            <li>
              <a href="#" onClick={e => e.preventDefault()}>
                Terms of Use
              </a>
            </li>
            <li>
              <a href="#" onClick={e => e.preventDefault()}>
                Compliance
              </a>
            </li>
            <li>
              <a href="#" onClick={e => e.preventDefault()}>
                Support
              </a>
            </li>
            <li>
              <a href="#" onClick={e => e.preventDefault()}>
                Contacts
              </a>
            </li>
          </ul>
          <div className="text-center">
            Copyright © 2017-2020 Mobidoc SA |{' '}
            <a href="https://getmobidoc.com/privacy" target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </Layout.Content>
  </Layout>
)

export default withRouter(connect(mapStateToProps)(MailLayout))
